module.exports = __webpack_public_path__ + "media/img/pages/profile/vaudoise ger 4-a30415ab7faf899b32bc51dea5449ce5.jpg";